import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { get, head, map } from 'lodash'
import { useHistory, useParams } from 'react-router-dom'
import {
  Paper,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer
} from '@material-ui/core'
import { Map } from './Map'
import Menu from '@material-ui/core/Menu'
import { Separator } from './Separator'
import { AddressSearch } from './AddressSearch'
import { confirmModal } from '../../v2_actions/ui'
import { setMapCenter } from '../../v2_actions/map'
import IconButton from '@material-ui/core/IconButton'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { DEFAULT_NUM_TEMS_PER_GALLERY_PAGE, galleryList } from '../../v2_actions/gallery'
import { useDispatch, useSelector } from 'react-redux'
import LoadingSpinner from '../../components/LoadingSpinner'
import { getUserStoredCountry } from "../../v2_actions/auth_country";
import { showSuccess, showError } from '../../v2_actions/error'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { briefGalleryListForPhotoArt } from '../../v2_actions/brief_gallery'
import { photographerLedgerList } from '../../v2_actions/photographer_ledger'
import { setSelectedGallery, setEditingGallery } from '../../actions/gallery'

const StyledTableCell = withStyles((theme) => ({
  head: {
    fontSize: 12,
    height: 10.823,
    color: 'black',
    fontWeight: 'bold',
    backgroundColor: '#E5E5E5',
    border: '1px solid #e0e0e0',
  },
  body: {
    height: 25,
    fontSize: 12,
    fontWeight: 400,
    textAlign: 'center',
    fontFamily: 'Helvetica'
  },
}))(TableCell)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: 'white',
      height: 25,
    },
  },
}))(TableRow)

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 99,
    opacity: '0.88',
    position: 'relative',
    padding: 10,
  },
  selectedInput: {
    width: '7px',
    '& .MuiInputBase-root': {
      height: '30px',
    },
  },
  clickIcon: {
    cursor: 'pointer',
  },
  actionWrapper: {
    top: '70px',
    right: '10px',
    position: 'absolute',
  },
}))

function format(x) {
  return Number.parseFloat(x).toFixed(2)
}

const SelectRow = ({ row, history, dispatch, onDeleted, key }) => {
  const gallery_id = get(row, 'id')
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedValue, setSelectedValue] = useState(false)
  

  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (event) => {
    
    setAnchorEl(null)
    setSelectedValue(event.target.getAttribute('value'))

    // Get attribute value from selected option
    let value = event.target.getAttribute('value')
    if (value === 'EDIT') {
      dispatch(setEditingGallery(row))
    }
  }

  return (
    <div>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            // maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
        // Should Open in bottom left side
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {/* <MenuItem onClick={handleClose} value='EDIT'> */}
        {/*   Edit Photo */}
        {/* </MenuItem> */}
        {/* <MenuItem
          value='DELETE'
          onClick={(e) => {
            onDeleted(row)
            handleClose(e)
          }}
        >
          Hide Photo
        </MenuItem> */}
      </Menu>
    </div>
  )
}

const AllPhotoArtGalleries = () => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const [isBusy, setIsBusy] = useState(false)
  const [showMap, setShowMap] = useState(false)
  const [selectedRowId, setSelectedRowId] = useState(null)
  const galleries = useSelector(() => briefGalleryListForPhotoArt.getVisibleObjects())
  const loadingGalleries = useSelector(() => briefGalleryListForPhotoArt.isLoading())

  useEffect(() => {
    dispatch(briefGalleryListForPhotoArt.invalidateList())
    dispatch(briefGalleryListForPhotoArt.updatePaginationNumItemsPerPage(DEFAULT_NUM_TEMS_PER_GALLERY_PAGE))
    dispatch(briefGalleryListForPhotoArt.updateListFilter({gallery_type: 'photo_art'}))
    dispatch(briefGalleryListForPhotoArt.fetchListIfNeeded())
  }, [])

  const formProps = useForm({})
  const {
    formState: { errors },
  } = formProps

  const onDeleteSelectedGallery = (json) => {
    const onDeleted = (json) => {
      if (json.errors) {
        showError('Error', JSON.stringify(json.errors))
      } else {
        dispatch(briefGalleryListForPhotoArt.invalidateList())
        dispatch(briefGalleryListForPhotoArt.fetchListIfNeeded())
        showSuccess('Removed', 'Photo hidden')
        setIsBusy(false)
      }
    }
    
    const onConfirmed = () => {
      const values = Object.assign({}, json, {
        available_to_purchase: false,
      })
      setIsBusy(true)
      dispatch(galleryList.saveObject(values)).then(onDeleted)
    }
    
    dispatch(
      confirmModal({
        can_cancel: true,
        onConfirmed: onConfirmed,
        text: 'Are you sure you want to make this photo unavailable to purchase?'
      }),
    )
  }

  const country = getUserStoredCountry()
  const showcase_gallery = useSelector(() =>
    head(photographerLedgerList.getVisibleObjects()),
  )
  const sum_balance_by_gallery_id = get(showcase_gallery, 'sum_balance')

  useEffect(() => {
    dispatch(photographerLedgerList.fetchListIfNeeded())
  }, [])

  const { gallery_id } = useParams()
  const gallery = useSelector(() => galleryList.getObject(gallery_id))
  const is_ready = !gallery_id || get(gallery, 'id')

  useEffect(() => {
    if (get(gallery, 'lat') && get(gallery, 'lng')) {
      dispatch(
        setMapCenter({ lat: get(gallery, 'lat'), lng: get(gallery, 'lng') }),
      )
    }
  }, [get(gallery, 'id')])

  useEffect(() => {
    dispatch(galleryList.fetchListIfNeeded())
    if (gallery_id) {
      dispatch(galleryList.ensureObjectLoaded(gallery_id))
    }
  }, [gallery_id])

  // useEffect(() => {
  //   const firstRow = head(galleries)
  //   if (!selectedRowId && !isEmpty(galleries)) {
  //     dispatch(setSelectedGallery(firstRow))
  //     setSelectedRowId(get(firstRow, 'id'))
  //   }
  // }, [galleries])

  const onSelectGallery = (gallery_id) => {
    history.push(`/photographer/gallery/${gallery_id}/view`)
  }

  return (
    <TableContainer
      component={ Paper }
      className={ classes.container }
    >
      <Separator height={ 3 } />
      { (isBusy || loadingGalleries) && <LoadingSpinner/> }
      <AddressSearch
        title={'Photo Art Pics'}
        isPhotoArtAddressSearch
        btnText='Load New Photo'
        path='photographer/photo_art_gallery/new'
        briefGalleryListInUse={ briefGalleryListForPhotoArt }
      />
      {/* <SideBarGalleryFilter
        isFilterForPhotoArt
      /> */}
      <Separator height={ 23 } />
      {!showMap && (
        <Table className={ classes.table } aria-label='customized table'>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align='center'>
                Date
              </StyledTableCell>
              <StyledTableCell align='center'>
                Photo Name
              </StyledTableCell>
              <StyledTableCell align='center'>
                Price
              </StyledTableCell>
              <StyledTableCell align='center'>
                Photograph
              </StyledTableCell>
              <StyledTableCell align='center'>
                Status
              </StyledTableCell>
              <StyledTableCell align='center'>
                Actions
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {galleries.map((row, index) => (
              <StyledTableRow
                hover
                key={`${row.id}-styledrow`}
                selected={selectedRowId === row.id}
                onClick={() => {
                  setSelectedRowId(row.id)
                  dispatch(setSelectedGallery(row))
                }}
              >
                <StyledTableCell scope='row' component='th'>
                  { moment(get(row, 'shot_at_datetime')).format('Do MMM YYYY') }
                </StyledTableCell>
                <StyledTableCell align='left'>
                  { get(row, 'session_name') }
                </StyledTableCell>
                <StyledTableCell align='left'>
                  { get(row, ['gallery_price', 'base_price']) }
                </StyledTableCell>
                <StyledTableCell align='left'>
                  <img
                    width='100px'
                    src={ get(row, ['gallery_photo_url']) }
                  />
                </StyledTableCell>
                <StyledTableCell align='left'>
                  { get(row, 'available_to_purchase') ? 'Live' : 'Hidden' }
                </StyledTableCell>
                <StyledTableCell
                  align='left'
                  className={ classes.selectedInput }
                >
                  <SelectRow
                    row={ row }
                    history={ history }
                    dispatch={ dispatch }
                    key={ `${row.id}-selectrow` }
                    onDeleted={ onDeleteSelectedGallery }
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      )}
      {showMap && (
        <Map
          markers={map(galleries, function (gallery) {
            return {
              name: gallery.gallery_name,
              onClick: () => onSelectGallery(gallery.id),
              position: { lat: gallery.lat, lng: gallery.lng },
              imageUrl: galleryList.getGalleryAvatarUrl(gallery)
            }
          })}
        />
      )}
    </TableContainer>
  )
}

export default AllPhotoArtGalleries